import { render, staticRenderFns } from "./DigitalMarketing.vue?vue&type=template&id=0da86083&scoped=true&"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMarketing.vue?vue&type=style&index=0&id=0da86083&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da86083",
  null
  
)

export default component.exports